import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import { htmlData } from "./StaticData";
const RediTerms = () => {
  return (
    <Container>
      <Row style={{padding:'5%'}}>
          <div dangerouslySetInnerHTML={{ __html: htmlData.data }} style={{width: '95%'}}/>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 95% !important;
  height: 100%;
  position: relative;
  float: none;
  margin: 0 auto;
  background: #fff;
  padding: 2%;
`;

export default RediTerms;
